import type { TariffBreakdownSubmissionPayload } from '@innogy/shared/tariff-breakdown/models';
import { createAction, props } from '@ngrx/store';

const PREFIX = `[Tariff Breakdown]`;

export const tariffBreakdownAddressDataSubmitAction = createAction(
  `${PREFIX} Address Data Submitted`,
  props<TariffBreakdownSubmissionPayload>()
);
